import { AgeCategory } from '../../../models/AgeCategory';
import { useLocation } from 'react-router';
import { useMemo } from 'react';

export const useAgeCategorySearchParam = () => {
    const { search } = useLocation();
    const ageCategory = new URLSearchParams(search).get('ageCategory');

    return useMemo(() => {
        switch (ageCategory) {
            case AgeCategory.ADULT:
                return { raw: ageCategory, value: AgeCategory.ADULT, searchParam: AgeCategory.ADULT };
            case AgeCategory.YOUNG_ADULT:
                return { raw: ageCategory, value: AgeCategory.YOUNG_ADULT, searchParam: AgeCategory.YOUNG_ADULT };
            case AgeCategory.CHILDREN:
                return { raw: ageCategory, value: AgeCategory.CHILDREN, searchParam: AgeCategory.CHILDREN };
            default:
                return { raw: ageCategory, value: AgeCategory.ALL_AGES, searchParam: undefined };
        }
    }, [ageCategory]);
};
